import { useGetServerlessMetricsEndpoint } from '@/service/serverless-gpu/hook';
import ServerlessGpuOverviewMetricsTasks from './tasks';
import ServerlessGpuOverviewMetricsUsages from './usage';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';
import { RouteParams } from '@/router/type';
import { useMemo } from 'react';

const ServerlessOverviewMetrics = () => {
  const { projectId } = useParams<RouteParams>();
  const startTime = useMemo(
    () => dayjs().subtract(24, 'hours').toISOString(),
    []
  );
  const endTime = useMemo(() => dayjs().toISOString(), []);

  const { data, isLoading } = useGetServerlessMetricsEndpoint({
    project_id: projectId!,
    start_date: startTime,
    end_date: endTime,
  });

  const dataTasks = useMemo(() => {
    if (!data?.function_data || !data?.server_data) return [];
    
    return data.function_data.map((item, index) => ({
      date: dayjs(item.timestamp).valueOf(),
      value: item.total_requests + (data?.server_data?.[index]?.total_requests || 0)
    }));
  }, [data]);

  const dataUsages = useMemo(() => {
    if (!data?.function_data || !data?.server_data) return [];
    
    return data.function_data.map((item, index) => ({
      date: dayjs(item.timestamp).valueOf(),
      total: item.total_usage + (data?.server_data?.[index]?.total_usage || 0)  
    }));
  }, [data]);

  const sumTotalTasks = useMemo(() => 
    dataTasks.reduce((acc, item) => acc + item.value, 0),
    [dataTasks]
  );

  const sumTotalUsages = useMemo(() => 
    dataUsages.reduce((acc, item) => acc + item.total, 0),
    [dataUsages]
  );

  return (
    <div>
      <div className="grid grid-cols-2 gap-4">
        <ServerlessGpuOverviewMetricsTasks data={dataTasks} sumTotal={sumTotalTasks} />
        <ServerlessGpuOverviewMetricsUsages data={dataUsages} sumTotal={sumTotalUsages} />
      </div>
    </div>
  );
};

export default ServerlessOverviewMetrics;
